import { orderRepository } from '~/api/repository/order';

export const ORDER_QUERY_KEY = {
  all: ['order'] as const,

  // 주문 내역 목록 조회 (무한 스크롤)
  histories: () => ({
    queryKey: ['/api/market-place/v1/orders'] as const,
    queryFn: ({ pageParam }: { pageParam?: number } = {}) =>
      orderRepository.getOrderHistories({ lastOrderId: pageParam }),
    infinite: true,
  }),

  // 주문 상세 조회
  detail: (orderId: number) => ({
    queryKey: ['/api/market-place/v2/orders/{orderId}/details', orderId] as const,
    queryFn: () => orderRepository.getOrderDetail(orderId),
  }),
};
